import React from "react";
import { InView } from "react-intersection-observer";

const DownloadApp = () => {
  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-6 flex flex-col items-center text-center">
        {/* Animated Content */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`max-w-2xl transform transition-transform ${
                inView ? "animate__animated animate__fadeInUp" : ""
              }`}
            >
              <h2 className="text-4xl font-bold text-gray-800 mb-4">
                Download Our App
              </h2>
              <p className="text-lg text-gray-600 mb-4">
                Get instant access to powerful design tools on your mobile!
                Download the <strong>EDIT EZY</strong> app to create beautiful
                posters, business cards, and marketing materials on the go.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Click the button below to download and install the app directly.
              </p>

              <a
                href="https://apkpure.com/group/in.poster.editezy"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 text-white font-semibold rounded-full shadow-lg bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 transition-colors duration-300"
              >
                Download Now
              </a>
            </div>
          )}
        </InView>
      </div>
    </div>
  );
};

export default DownloadApp;
